import React, { useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useEnvironment } from '../../contexts/EnvironmentContext';
import DestinationDialog from '../../components/deliveries/DestinationDialog';

/**
 * Settings -> Deliveries: environment-default destinations (docs/connectors/PLAN.md step 8).
 * Reuses the same `DestinationDialog` a flow's own delivery settings use, scoped to the
 * environment instead of one flow, so a merchant sets up "email every booking to me" once per
 * environment rather than repeating it on every flow.
 */
const DeliveriesSettings = () => {
  const { selectedEnvironment } = useEnvironment();
  const [open, setOpen] = useState(false);

  if (!selectedEnvironment) {
    return <Alert severity="warning">Please select an environment first</Alert>;
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Deliveries
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Environment-default destinations apply to every flow in {selectedEnvironment.name}
          {' '}unless that flow has its own destination of the same type. A flow can always
          override a default from its own delivery settings.
        </Typography>
        <Box>
          <Button
            variant="contained"
            startIcon={<SettingsIcon />}
            onClick={() => setOpen(true)}
            data-testid="open-environment-destinations"
          >
            Manage environment defaults
          </Button>
        </Box>
      </CardContent>

      <DestinationDialog open={open} onClose={() => setOpen(false)} scope="ENVIRONMENT_DEFAULT" />
    </Card>
  );
};

export default DeliveriesSettings;
